import { useEffect } from 'react';
import { useMap } from 'react-map-gl/mapbox';

const useMapPinInteractivity = (isTrainPinned: boolean) => {
  const { current: mapRef } = useMap();

  useEffect(() => {
    const map = mapRef?.getMap();

    if (!map) {
      return;
    }

    if (isTrainPinned) {
      map.dragPan.disable();
      map.boxZoom.disable();
      map.doubleClickZoom.disable();
      map.scrollZoom.enable({ around: 'center' });
    } else {
      map.dragPan.enable();
      map.boxZoom.enable();
      map.doubleClickZoom.enable();
      map.scrollZoom.enable();
    }
  }, [mapRef, isTrainPinned]);
};

export default useMapPinInteractivity;
